import { baseColors } from './baseColors';

export const label = {
  color: baseColors.text.label,
};
